import { render, staticRenderFns } from "./nav-user-management.vue?vue&type=template&id=36c35070&"
import script from "./nav-user-management.vue?vue&type=script&lang=ts&"
export * from "./nav-user-management.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports